import { StyledIcon } from "@styled-icons/styled-icon";
import React from "react";

type Props = {
  Icon: StyledIcon;
} & React.HTMLAttributes<SVGSVGElement>;

export const DynamicIcon = React.forwardRef<SVGSVGElement, Props>(({ Icon, ...props }, ref) => {
  return <Icon ref={ref} {...props} />;
});
